import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { cn } from '../../utils/cn';
interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  className?: string;
}
export function Drawer({
  isOpen,
  onClose,
  children,
  title,
  className
}: DrawerProps) {
  // Prevent body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-360">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" data-id="element-361" />

          {/* Drawer Panel */}
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className={cn('fixed right-0 top-0 z-50 h-full w-full max-w-md border-l border-gray-800 bg-[#1a1d23] shadow-2xl', className)} data-id="element-362">
            <div className="flex h-full flex-col" data-id="element-363">
              <div className="flex items-center justify-between border-b border-gray-800 px-6 py-4" data-id="element-364">
                <h2 className="text-lg font-semibold text-white" data-id="element-365">{title}</h2>
                <button onClick={onClose} className="rounded-md p-2 text-gray-400 hover:bg-gray-800 hover:text-white focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-366">
                  <X className="h-5 w-5" data-id="element-367" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto p-6" data-id="element-368">{children}</div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}